declare let mxGeometryChange: any; // available globally
declare let mxStyleChange: any; // available globally
declare let mxTerminalChange: any; // available globally
import {xmlToObj} from '../../diagram-render/helpers/xml-to-obj.util';
import * as _ from 'lodash';

export function imageGraphChange(graph, cell, change) {
  const geometry = cell.geometry;
  const action: any = {};
  let shouldSkip = false;

  action.mxKey = Number(cell.id);
  action.position = {
    x: geometry.x,
    y: geometry.y,
    w: geometry.width,
    h: geometry.height
  };
  action.position.r = graph.getCellStyle(cell)['rotation'] || 0;

  if (change instanceof mxStyleChange) {
    shouldSkip = true;
    const prev = xmlToObj(change.previous);
    const curr = xmlToObj(change.style);

    if (prev.rotation !== curr.rotation) {
      shouldSkip = false;
      action.position.r = Number(curr.rotation) || 0;
    }

    if (Boolean(+prev.locked) !== Boolean(+curr.locked)) {
      shouldSkip = false;
      action.locked = Boolean(+curr.locked);
    }
  }

  return shouldSkip
    ? null
    : {
        data: _.cloneDeep(action),
        action: 'changeImage',
        type: 'image',
        mxKey: Number(cell.id)
      };
}
